import {Component} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-datetime-test',
  templateUrl: './datetime-test.component.html',
  standalone: false,
})
export class DatetimeTestComponent {
  reactiveForm = new FormGroup({
    datetime: new FormControl<string | null>(null),
    dateOnly: new FormControl<string | null>(null),
    withDefault: new FormControl<string | null>('2026-07-04T15:30:00'),
    onlyDateWithDefault: new FormControl<string | null>('2026-07-04'),
    minuteStep1: new FormControl<string | null>(null),
    disabled: new FormControl<string | null>({value: '2026-12-25T09:00:00', disabled: true}),
    prefilledNow: new FormControl<string | null>(DateTime.now().toFormat("yyyy-MM-dd'T'HH:mm:00")),
  });

  ngModelDatetime: string | null = null;
  ngModelDateOnly: string | null = null;

  minDate = DateTime.now().startOf('day');
  maxDate = DateTime.now().plus({years: 1}).endOf('day');
}
